import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AgentData} from '../../../model/agent-page-data';

@Injectable()
export class OurTeamService {

  constructor(private http: HttpClient) {
  }

  getAllUsers(): Observable<AgentData[]> {
    return this.http.get<AgentData[]>(environment.serverUrl + '/users/get-all');
  }

}
